import { atom } from 'recoil';

import { DEFAULT_PRICE_FORMAT } from '@ecp/common/src/const/price/priceConst';

import { MOBILE_APP_STATUS } from '@ecp/mo/src/const/system/mobileConst';

export const systemInfoFetchPendingState = atom({
  key: 'systemInformationFetchPendingState',
  default: false,
});

export const systemInformationState = atom({
  key: 'systemInformationStateMo',
  default: {
    clientName: '',
    clientRepresentativeName: '',
    clientRepresentativeTel01: '',
    clientRepresentativeTel02: '',
    clientRepresentativeTel03: '',
    couponUseYn: '',
    isPossibleKnoxLogin: '',
    isMultimall: true,
    logoImgBtypeUseYn: '',
    mobileGnbImgFilePath: '',
    mobileLoginImgFilePath: '',
    mobileFooterImgFilePath: '',
    pcFooterImgFilePath: '',
    pcGnbImgFilePath: '',
    pcLoginImgFilePath: '',
    pcLoginPhrase: '',
    mobileLoginPhrase01: '',
    mobileLoginPhrase02: '',
    loginQuestUseYn: '',
    memberAddInfoInptYn: '',
    memberEntryMeanCode: '',
    memberGendInptYn: '',
    memberGradeUseYn: '',
    pointUseYn: '',
    possibleKnoxLogin: '',
    promoBannerBtypeUseYn: '',
    pcPromoBannerImgFilePath: '',
    savingsUseYn: '',
    otoQuestUseYn: '',
    siteDescription: '',
    siteName: '',
    useYn: '',
    customerCenterOpStartHh: '',
    customerCenterOpEndHh: '',
    customerCenterLchStartHh: '',
    customerCenterLchEndHh: '',
    siteTypeCode: '',
    mktingUseYn: '',
    pntExpsNm: '',
    cartUseYn: '',
    priceExpsUseYn: '',
    // 가격 단위 (마일리지, 포인트 등)
    priceFormat: DEFAULT_PRICE_FORMAT,
    // 가격 단위 환산 (n원 = 1가격단위)
    priceFormatPerKrw: 1,
    couponMenuExpsYn: '',
    bulkOrdMenuUseYn: '',
    mobileGcfOrdListMenuUseYn: '', // [WIP-29281] 모바일 상품권 주문내역 사용 여부
    noMemberUseYn: '',
  },
});

export const mobileAppState = atom({
  key: 'mobileAppState',
  default: {
    isMobileApp: false,
    agentType: 'MOBILE_WEB',
    neededUpdate: false,
    versionUpdateType: MOBILE_APP_STATUS.NOT_APPLICABLE,
  },
});
